// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_DeletaUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/deletaUsuario
 *
 * Permanently deletes a user account by their Cognito sub.
 */
import { registerContract } from './validate'

export interface Usuarios_DeletaUsuarioInput {
sub: string
}

registerContract('Usuarios_DeletaUsuarioInput', {
  sub: { type: 'string',  required: true },
})
